import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';

@Component({
  selector: 'app-me-perfil-locais',
  templateUrl: './me-perfil-locais.component.html',
  styleUrls: ['./me-perfil-locais.component.css']
})
export class MePerfilLocaisComponent implements OnInit {
  hideCL: boolean = false;
  nomeCidade: any = '';
  qBuscado: any = '';
  arrResults: any[] = [];
  arrLoc: any[] = [];
  urlFoto: any = '';
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) { }

  ngOnInit() {
    this.tmaService.eventoFS(true);
    this.listarDadosComp(this.tmaService.hcNomeUsuario, 'locais');
    this.arrResults.push({qq: 1});
  }
  ngOnDestroy(){
    console.log("destroy");
    this.tmaService.eventoFS(false);
  }
  listarDadosComp(qUsuario : any, qTipoDetail) :void{
    //parte do servidor
    this.hideCL = false;
    var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&usuario=' + qUsuario + '&tipodado=' + qTipoDetail + '&meuindex=0';
    this.tmaService.listarDadosPerfil(dadosIn)
    .subscribe((qRes) =>{
      console.log(qRes);
      if(qRes['res'] == 'done'){
        if(qTipoDetail == 'locais'){
          this.arrLoc = qRes['arrResultado'];
          this.urlFoto =  "https://apptamas.melhorpedida.com/fotosusuarios/";
        }
      }
      this.hideCL = true;
    })
  } 

    goPoL(urlAmigavel: any) :void{
    this.tmaService.paginaAnterior = 'lista';
    this.router.navigate(['/local/' + urlAmigavel]);
  }
  trocarCidade() :void{
    this.router.navigate(['/pesquisando/' +  this.route.snapshot.paramMap.get('tipobuscado')])
  }

  voltar() :void{
    this.router.navigate(['/me/perfil']);
  }

}
